<template>
    <modal name="project-copy-modal" :pivotY="0.2" width="590" height="auto">
        <div class="modal-img-container">
            <img class="modal-img" :src="titleImageProject(projectGUID)"/>
        </div>
        <div class="modal-close-btn-point">
            <div class="modal-close-btn-container" v-on:click="hideModal('project-copy-modal')">
                <SVGModalClose/>
            </div>
        </div>
        <div class="modal-title">
            Копировать проект
        </div>
        <div class="modal-text">
            Создать копию проекта<span class="bold-text"> {{nameProject}}</span> с именем:
        </div>
        <input class="modal-text-input" type="text" v-model="nameNewProject">
        <div class="modal-button" v-on:click="copyProject">
            Создать
        </div>
    </modal>
</template>

<script>
    import {modalMethods, urlForFileStorage, urlForStaticVue} from "../common";
    import SVGModalClose from "../SVG/SVGModalClose.vue";

    export default {
        name: "ModalCopyProject",
        components: {SVGModalClose},
        mixins: [urlForStaticVue, urlForFileStorage, modalMethods],
        computed:{
            nameProject(){
                const nameProject = this.$store.getters['active/NAME'];
                this.nameNewProject = 'Копия ' + nameProject;
                return nameProject
            },
            projectGUID() {
                return this.$store.state.route.params.projectUUID
            }
        },
        data() {
            return {
                nameNewProject: ""
            }
        },
        methods:{
            copyProject: async function () {
                this.hideModal('project-copy-modal');
                const uuidNewProject = await this.$store.dispatch('UI/loadedProjectList/COPY_ACTIVE_PROJECT', this.nameNewProject);
                if(uuidNewProject){
                    this.$router.push({name: 'loadPhoto', params: {projectUUID: uuidNewProject}}).catch(err => {});
                } else {
                    console.error('Что-то пошло не так! Копия не создалась.');
                }
            },
            titleImageProject(projectGUID) {
                const src = this.$store.getters[`projectList/${projectGUID}/photoList/SRC_FIRST_PHOTO`];
                if (src) {
                    return this.urlForFileStorage(src);
                } else {
                    return this.urlForStatic('img/No_Picture.jpg');
                }
            }
        }
    }
</script>

<style scoped>

</style>
